<template>
<div id="articleVocabulary">
  <div v-if="filteredSutraVersionList.length">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <router-link class="breadcrumb-item" to="/avatamsaka/chooseArticle">
          {{$t('avatamsaka.versions.articleRead')}}
        </router-link>
        <li class="breadcrumb-item active" aria-current="page" v-if="filteredSutraList.length">
          {{$t('avatamsaka.sutras.sutra', {
            'noticeType': $t(`avatamsaka.sutras.sutra0${sutraId}books[${versionId-1}].text`)
          })}}
        </li>
      </ol>
    </nav>
    <div class="changeTabs">
      <div class="tabs">
        <ul>
          <li class="uncheckTab">
            <router-link class="breadcrumb-item"
            :to="{path: '/avatamsaka/version/' + versionId + '/sutra/' + sutraId + '/article'}">
              {{$t('avatamsaka.articles.read')}}
            </router-link>
          </li>
          <li>
            {{$t('avatamsaka.articles.contrast')}}
          </li>
        </ul>
      </div>
    <div class="content">
      <div class="singleContent">
        <componentTexts/>
      </div>

      <div class="vocabularies">
          <h2>{{$t('avatamsaka.articles.contrast')}}</h2>
          <ul>
            <li>
              <span class="sutraTitle">
                {{$t('avatamsaka.sutras.sutra', {
                  'noticeType': $t(`avatamsaka.sutras.sutra01booksArticleVoc[0].text`)
                })}}
              </span>
            <hr/>
              <span class="sutraContent">
                {{vocabulariesContent.v1voc}}
              </span>
            </li>
            <li>
              <span class="sutraTitle">
                {{$t('avatamsaka.sutras.sutra', {
                  'noticeType': $t(`avatamsaka.sutras.sutra01booksArticleVoc[1].text`)
                })}}
              </span>
            <hr/>
               <span class="sutraContent">
               {{vocabulariesContent.v2voc}}
               </span>
            </li>
            <li>
              <span class="sutraTitle">
                {{$t('avatamsaka.sutras.sutra', {
                  'noticeType': $t(`avatamsaka.sutras.sutra01booksArticleVoc[2].text`)
                })}}
              </span>
            <hr/>
              <span class="sutraContent">
                {{vocabulariesContent.v3voc}}
              </span>
            </li>
            <li>
              <span class="sutraTitle">
                {{$t('avatamsaka.sutras.sutra', {
                  'noticeType': $t(`avatamsaka.sutras.sutra01booksArticleVoc[4].text`)
                })}}
              </span>
            <hr/>
              <span class="sutraContent">
                {{vocabulariesContent.v4voc}}
              </span>
            </li>
            <li>
              <span class="sutraTitle">
                {{$t('avatamsaka.sutras.sutra', {
                  'noticeType': $t(`avatamsaka.sutras.sutra01booksArticleVoc[3].text`)
                })}}
              </span>
            <hr/>
              <span class="sutraContent">
                {{vocabulariesContent.v5voc}}
              </span>
            </li>
          </ul>
          <ul v-if="vocabulariesPSContent !== 'no change'">
            <br/>
            <li>
              <hr/>
              <br/>
              <h2>
                {{$t('avatamsaka.sutras.sutraArticleVocPS')}}
              </h2>
            </li>
            <li v-if="vocabulariesPSContent.v1 !== null">
              {{$t('avatamsaka.sutras.sutra', {
                'noticeType': $t(`avatamsaka.sutras.sutra01booksArticleVoc[0].text`)
              })}}
            <hr/>
              {{vocabulariesPSContent.v1}}
            </li>
            <li v-if="vocabulariesPSContent.v2 !== null">
              {{$t('avatamsaka.sutras.sutra', {
                'noticeType': $t(`avatamsaka.sutras.sutra01booksArticleVoc[1].text`)
              })}}
            <hr/>
               {{vocabulariesPSContent.v2}}
            </li>
            <li v-if="vocabulariesPSContent.v3 !== null">
              {{$t('avatamsaka.sutras.sutra', {
                'noticeType': $t(`avatamsaka.sutras.sutra01booksArticleVoc[2].text`)
              })}}
            <hr/>
              {{vocabulariesPSContent.v3}}
            </li>
            <li  v-if="vocabulariesPSContent.v5 !== null">
              {{$t('avatamsaka.sutras.sutra', {
                'noticeType': $t(`avatamsaka.sutras.sutra01booksArticleVoc[4].text`)
              })}}
            <hr/>
              {{vocabulariesPSContent.v5}}
            </li>
            <li v-if="vocabulariesPSContent.v4 !== null">
              {{$t('avatamsaka.sutras.sutra', {
                'noticeType': $t(`avatamsaka.sutras.sutra01booksArticleVoc[3].text`)
              })}}
            <hr/>
              {{vocabulariesPSContent.v4}}
            </li>
            <li v-if="vocabulariesPSContent.other !== null" v-html="vocabulariesPSContent.other">
            </li>
          </ul>
      </div>
    </div>
  </div>

  </div>
  <div class="noThisVer" v-if="noThisVer">
    {{$t('avatamsaka.other.chooseOtherVer')}}
    <ul>
      <li @click="getVersionPath(1)">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[0].text`)
        })}}
      </li>
      <li @click="getVersionPath(2)">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[1].text`)
        })}}
      </li>
      <li @click="getVersionPath(3)">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[2].text`)
        })}}
      </li>
      <li @click="getVersionPath(4)">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[3].text`)
        })}}
      </li>
      <li @click="getVersionPath(5)">
        {{$t('avatamsaka.versions.version', {
          'noticeType': $t(`avatamsaka.versions.type[4].text`)
        })}}
      </li>
    </ul>
  </div>

</div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue';
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'version',
  data() {
    return {
      test: { a: 'WORK!' },
      picked: 'words',
      read: 'no',
      noThisVer: false,
      vocabulariesContent: 'no change',
      vocabulariesPSContent: 'no change',
    };
  },
  created () {
    const articlePath = `s${this.sutraId}to3.vue`;
    const versionId = this.versionId;
    Vue.component('componentTexts', function (resolve, reject) {
      require([`@/components/texts/v${versionId}${articlePath}`], resolve)
    });
  },
  computed: {
    ...mapState(['selected', 'mouseX', 'mouseY']),
    vocabulariesList() {
      return this.$store.state.vocabulariesList;
    },
    vocabulariesPSList() {
      return this.$store.state.vocabulariesPSList;
    },
    versionId() {
      return this.$route.params.vid;
    },
    versionList() {
      return this.$store.state.versionList;
    },
    sutraList() {
      return this.$store.state.sutraList;
    },
    versions() {
      return this.$store.getters.versions;
    },
    sutraId() {
      return this.$route.params.sid;
    },
    filteredVersionList() {
      let versionList = [...this.versionList];
      const nowVersionId = Number(this.versionId);

      if (nowVersionId !== '') {
        versionList = versionList.filter(item => item.id === nowVersionId);
      }

      return versionList;
    },
    filteredSutraList() {
      let listSutra = [...this.sutraList];
      const nowSutraId = Number(this.sutraId);

      if (nowSutraId !== '') {
        listSutra = listSutra.filter(item => item.sutraId === nowSutraId);
      }
      listSutra = listSutra[0].name;
      const listSutraName = this.$i18n.t(listSutra);
      return listSutraName;
    },
    filteredSutraVersionList() {
      let sutraList = [...this.filteredVersionList];

      if (sutraList.length !== 0) {
        sutraList = this.filteredVersionList[0].contents;
      }

      const nowSutraId = Number(this.sutraId);

      if (nowSutraId !== '') {
        sutraList = sutraList.filter(item => item.sutraId === nowSutraId);
      }

      return sutraList;
    },
  },
  watch: {
    filteredSutraVersionList: function noVersion() {

      let versionEx = false;
      const versionList = [...this.filteredVersionList];
      const sutraList = [...this.filteredSutraVersionList]

      if (versionList.length !== undefined) {
        if (versionList.length === 0 || sutraList.length === 0) {
          versionEx = true;
        }
      }

      this.noThisVer = versionEx;
    },
    selected: function changeContent() {
      const vocabulariesList = [...this.vocabulariesList];
      const vocabulariesPSList = [...this.vocabulariesPSList];
      const nowSutra = `s${this.sutraId}`;
      let vocabulariesContent = '';
      let vocabulariesPSContent = '';
      if (vocabulariesList.length !== undefined && vocabulariesList.length !== null) {
        vocabulariesContent = vocabulariesList.find(item => item.sutra == nowSutra).vocabularies;
        vocabulariesContent = vocabulariesContent.find(item => item.tag == this.selected);
      }
      if (vocabulariesContent !== undefined) {
        this.vocabulariesContent = vocabulariesContent;
        console.log('vocabulariesContent.PS', vocabulariesContent.PS);
        if (vocabulariesContent.PS !== null ) {
          vocabulariesPSContent = vocabulariesPSList.find(item => item.sutra == nowSutra).vocabularies;
          vocabulariesPSContent = vocabulariesPSContent.find(item => item.no == vocabulariesContent.PS);
          this.vocabulariesPSContent = vocabulariesPSContent;
        } else {
          this.vocabulariesPSContent = 'no change';
        }
      } else {
        this.vocabulariesContent = {
          tag: '',
          v1voc: '',
          v2voc: '',
          v3voc: '',
          v4voc: '',
          v5voc: '',
          PS: ''
        };
      };
    },
  },
  methods: {
    ...mapMutations(['updateTagClick']),
    getVersionPath(versionId) {
      this.$router.push({
        name: 'version',
        params: {
          vid: versionId,
        },
      });
    },
  },
  mounted() {
    this.updateTagClick(true);
    this.$store.dispatch('getSutraList');
    this.$store.dispatch('getVersionList');
    this.$store.dispatch('getVocabulariesList');
    this.$store.dispatch('getVocabulariesPSList');
  },
};
</script>

<style lang="scss" scoped>
#articleVocabulary {
  .icon-stop2{
    background: red;
    border: 15px solid blue;
  }

    .noThisVer {
        padding: 45px;
        font-size: 1.2em;
        ul {
            list-style: none;
            li {
                margin: 10px;
                padding: 5px;
                background: rgb(221, 242, 219);
            }
            li:hover {
                cursor: pointer;
                background: rgb(241, 235, 178);
            }
        }
    }

    button {
        margin: 5px 3px;
    }

    .changeTabs {
      margin: 40px 20px;
      margin-bottom: 0px;
      text-align: left;
      display: flex;
      flex-direction: column;
      .tabs {
        margin: 0px 20px;
        ul {
          list-style: none;
          padding: 0px;
          margin: 0px;
          color: #fff;
          li {
            float: left;
            padding: 5px 10px;
            border: 1px solid black;
            border-bottom: none;
            list-style: none;
            background: #505444;
          }
          .uncheckTab {
            background: rgba(#505444, 0.4);
            border: none;
            border-top: 1px solid #b8bbb4;
            .breadcrumb-item {
              color: #fff;
            }
          }
        }
      }
    }

    .content {
        display: flex;
        border: 1px solid black;
        margin: 40px 20px;
        margin-top: 0px;
        min-height: 500px;
        height: 700px;
        flex-direction: row;
        text-align: left;

        .vocabularies {

            height: 100%;
            width: 25%;
            min-width: 250px;
            flex: initial;
            padding: 10px;
            border-left: 1px solid black;
            position: relative;
            overflow: auto;

            ul {
              list-style: none;
              margin: 0px;
              padding: 0px;

              li {
                margin-top: 2em;
                min-height: 2em;
                width: 100%;
                padding: 0.5em;

                .sutraContent {
                  font-weight: bolder;
                }
              }
              li:nth-child(odd) {
                background: #e5f1ec;
              }
            }

            h1 {
                font-family: 'Open Sans', sans-serif;
                font-size: 13pt;
                font-weight: 600;
                text-transform: uppercase;
                color: white;
                cursor: default;
            }

            h4 {
                font-family: 'Open Sans', sans-serif;
                font-size: 8pt;
                font-weight: 400;
                cursor: default;
            }

            h2 {
                font-family: 'Open Sans', sans-serif;
                font-size: 1.5em;
                font-weight: bolder;
                color: #505444;
                cursor: default;
                margin-bottom: 20px;
                text-align: center;
            }

            @mixin unselectable() {
                -webkit-touch-callout: none;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
            }

        }

        .singleContent {
            flex: 1;
            padding: 5px;
            overflow: scroll;
            -webkit-overflow-scrolling : touch;
            border: none;
            height: 100%;
        }

    }

    @media (max-width: 768px) {
      .content {
        height: 80vh;
      }

      .content {
        display: flex;
        flex-direction: row;

        .vocabularies {
          flex: initial;
          font-size: 0.8em;
          border-left: 1px solid #000000;
          padding-top: 0.8em;
          width: 6em;
          min-width: 6em;
          max-width: 6em;
        }

        > .singleContent {
          flex: 1;
        }

    }
    }

}

</style>



// WEBPACK FOOTER //
// src/components/ArticleVocabulary.vue